module.exports = __webpack_public_path__ + "media/images/default/pages/about/5-04e2afe3e00c19e23811d87d5da7bf1f.jpg";